import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { GlobalsPaths } from '../app.config';
import { AuthenticationService } from '../_services/index';
import { ToasterErrorService } from '../_services/toaster.service';
import { PermissionService } from '../_services/permission.service';
import { CookieService } from 'ngx-cookie-service';
import { LanguagesStaticText } from 'app/_services/language.servic';
import { environment } from 'environments/environment';


@Component({
  moduleId: module.id,
  // tslint:disable-next-line:component-selector
  selector: 'login-app',
  templateUrl: `./login.html`
})

export class LoginComponent implements OnInit {
  img: string = this.globalsPaths.img;
  model: any = {};
  loading: boolean = false;
  error = '';
  pageLoaded: boolean = false;
  toasterconfig = this.toasterErrorService.toasterconfig;
  returnUrl: string;
  parametersSub: any;
  currentUser: any;
  public languages: any[] = [];
  public selectedLanguage: string = localStorage.getItem('SelectedLanguage') || "EN";

  constructor(
    private route: ActivatedRoute,
    private globalsPaths: GlobalsPaths,
    private router: Router,
    private authenticationService: AuthenticationService,
    private toasterErrorService: ToasterErrorService,
    private languagesStaticText: LanguagesStaticText,
    private permissions: PermissionService
  ) {
    this.languagesStaticText.language_configs$.subscribe((value) => {
      this.languages = value
    });
  }

  async ngOnInit() {

    const authCookie = await this.authenticationService.getAuthCookie();
    debugger
    // TODO - need to check if these two lines work with SSO login
    this.selectedLanguage = localStorage.getItem('SelectedLanguage') || "EN";
    localStorage.removeItem('currentUser');

    if (authCookie) {
      const valueTrue = await this.authenticationService.ssoLogin();
      if (valueTrue) {
        // console.log('ngOnInit: if authCookie and valueTrue - logged in ');
        this.router.navigateByUrl('/home');
      }
    } else {
      console.log('ngOnInit: else authCookie - not logged in redirect to SSO');
      // Not logged in
      this.loginSSO();
    }

  }





  async loginSSO() {
    this.loading = true;
    const authResponse: boolean = await this.authenticationService.ssoLogin();

    if (authResponse) {
      console.log('Successfull login');
      this.authenticationService.GetCurrentCustomer().then((result: any) => {
        const customer: any = result;
        console.log("login.ts // Customer Model", customer);
        localStorage.setItem('currentUser', JSON.stringify(customer))

        this.languagesStaticText.setUserLanguages(customer.languages);
        const _currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log("login.ts // _currentUser", _currentUser);
        if (_currentUser) {
          this.permissions.setPermissionsAndRoles(_currentUser.user);
        }
        this.router.navigateByUrl(this.returnUrl);

      }, (err) => {
        console.log('GetCurrentUser login: ', err);
      });

    } else {
      // If we are not logged in we will get re-directed.
      console.log('ssoLogin return false');
    }
  }




  login() {
    this.loading = true;

    this.authenticationService.login(this.model.email, this.model.password)
      .subscribe(
        successData => {
          console.log('Successfull login');
          this.authenticationService.GetCurrentCustomer().then((result: any) => {
            const customer: any = result;
            console.log("login.ts // Customer Model", customer);
            localStorage.setItem('CurrentUser', JSON.stringify(customer))
            this.languagesStaticText.setUserLanguages(customer.languages)

          }, (err) => {
            console.log('GetCurrentUser login: ', err);
          });

          const _currentUser = JSON.parse(localStorage.getItem('currentUser'));
          if (_currentUser) {
            this.permissions.setPermissionsAndRoles(_currentUser.user);
          }
          this.loading = false;
          // login successful so redirect to return url
          this.router.navigateByUrl(this.returnUrl);
        },
        errData => {
          this.loading = false;
          const errMsg = JSON.parse(errData._body)['non_field_errors'][0];
          console.log('UNsuccessfull login: ', errMsg);
          this.toasterErrorService.toasterCredentials(errMsg);
        }
      );
  }

  onChangeLanguage(e) {
    this.languagesStaticText.handleChangeLanguage(e.value);
    this.selectedLanguage = e.target.value
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Login/login.component.ts